import * as React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../App";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Box,
  StatGroup,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow
} from "@chakra-ui/core";
import Gemeente from "../../store/Gemeente";
import useComponentSize from "../../hook/useComponentSize";
import Chart from "./Chart";
import Day from "../../store/Day";
import Provincie from "../../store/Provincie";
import Base from "../../store/Base";

export default observer(function Info() {
  const store = useStore();

  const onClose = () => {
    store.activeBase = null;
  };

  const isOpen = store.activeBase !== null;

  const title = store.activeBase ? store.activeBase.name : "";
  return (
    <Drawer size="md" isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{title}</DrawerHeader>

        <DrawerBody overflowY="auto">
          {store.activeBase && <InfoBody base={store.activeBase} days={store.days} />}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
});

function InfoBody({ base, days }: { base: Base; days: Day[] }) {
  const ref = React.useRef<HTMLDivElement>();
  const size = useComponentSize(ref);

  return (
    <Box ref={ref}>
      <StatGroup>
        <Stat>
          <StatLabel>Inwoners</StatLabel>
          <StatNumber>{new Intl.NumberFormat("nl-NL").format(base.inhabitants)}</StatNumber>
        </Stat>

        <Stat>
          <StatLabel>Totaal</StatLabel>
          <StatNumber>{base.total}</StatNumber>
          <StatHelpText>
            <StatArrow type="increase" />
            {base.totalP}%
          </StatHelpText>
        </Stat>
        <Stat>
          <StatLabel>Nieuw</StatLabel>
          <StatNumber>{base.delta}</StatNumber>
          <StatHelpText>
            <StatArrow type="increase" />
            {base.deltaP}%
          </StatHelpText>
        </Stat>
      </StatGroup>

      <Chart
        width={size.width}
        data={days
          .map(d => ({
            name: d.label,
            total: base.totals[d.index],
            delta: base.deltas[d.index]
          }))
          .reverse()}
      />
    </Box>
  );
}
